(function waitForjQuery() {
    if (window.jQuery) {
        initSC(window.jQuery);
    } else {
        setTimeout(waitForjQuery, 20);
    }
})();

function initSC($) {
    var sc = sc || {};

    // Replace SC in text nodes
    sc.rewriteText = function () {
        $('body').find('*').contents().filter(function () {
            return this.nodeType === 3; // text node
        }).each(function () {
            var text = this.nodeValue;
            var newText = text.replace(/SC /g, '');
            if (text !== newText) {
                this.nodeValue = newText;
            }
        });
    };

    // DEV
    sc.dev = function () {
        let path = window.location.pathname; // example: "/collections/sc-fly-copy/sc-freshwater"

        // Allowed subcollection endpoints
        let pages = [
            // '/collections/sc-freshwater',
            // '/collections/sc-saltwater',
            //'/collections/sc-travel',
            //'/collections/sc-fly',
            //'/collections/sc-ice',
            '/collections/ghytsdftestfordevcollection'
        ];

        // Match ONLY if the path *exactly ends* with the allowed subcollection
        let isExactSubcollection = pages.some(page => path.endsWith(page));

        if (isExactSubcollection && !window.location.search.includes('view=subcollections')) {
            window.location.href = window.location.href + (window.location.search ? '&' : '?') + 'view=subcollections';
        }

        //if page is pages/register-your-st-croix-rod add ?view=rod-registration
        // if (path.endsWith('/pages/register-your-st-croix-rod') && !window.location.search.includes('view=rod-registration')) {
        //     window.location.href = window.location.href + (window.location.search ? '&' : '?') + 'view=rod-registration';
        // }

        //if page is pages/register-your-st-croix-rod add ?view=customer-app
        if (path.endsWith('/pages/customer-appreciation-day') && !window.location.search.includes('view=customer-app')) {
            window.location.href = window.location.href + (window.location.search ? '&' : '?') + 'view=customer-app';
        }        

        //if page is pages/register-your-st-croix-rod add ?view=factory-tour
        // if (path.endsWith('/pages/factory-tours') && !window.location.search.includes('view=factory-tour')) {
        //     window.location.href = window.location.href + (window.location.search ? '&' : '?') + 'view=factory-tour';
        // }

        //straight forward redirect for pages/st-croix-rod-warranty to /pages/register-your-st-croix-rod?view=rod-registration
        if (path.endsWith('/pages/st-croix-rod-warranty')) {
            window.location.href = '/pages/register-your-st-croix-rod?view=rod-registration';
        }

        if (path.endsWith('/pages/st-croix-factory-store-delivers-anglers-the-upper-hand-come-see-in-person') && !window.location.search.includes('view=visit-store')) {
            window.location.href = window.location.href + (window.location.search ? '&' : '?') + 'view=visit-store';
        }

    };

    sc.mobileRewards = function(){
        $('#site-mobile-nav .navmenu-depth-1').append('<li style="" class="navmenu-item navmenu-id-rewards"><a href="/pages/rewards" class="navmenu-link" role="button">Rewards</a></li>')
    }

    // EDN DEV


    $(document).ready(function(){
        sc.rewriteText();
        sc.dev();
        sc.mobileRewards();
    });
}
